// extracted by mini-css-extract-plugin
export default {"mainContainer":"Projects_mainContainer__SwDUZ","yearContainer":"Projects_yearContainer__aJcrq","title":"Projects_title__tBYLF"};